import React, { ChangeEvent, useEffect, useState } from "react";

import { CheckboxProp } from "./types";

import ErrorText from "../ErrorText/ErrorText";

import "./styles.scss";

const Checkbox = ({
  disabled,
  title,
  defaultValue = false,
  error,
  handleCheckboxChange,
}: CheckboxProp): JSX.Element => {
  const [isChecked, setIsChecked] = useState<boolean>(defaultValue);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    const value = e?.target?.checked;
    setIsChecked(value);
    if (handleCheckboxChange) {
      handleCheckboxChange(value);
    }
  };

  useEffect(() => {
    if (defaultValue) {
      setIsChecked(defaultValue);
    }
  }, [defaultValue]);

  return (
    <>
      <div className="d-flex items-center checkbox-wrapper">
        <input
          className="checkbox"
          type="checkbox"
          disabled={disabled}
          checked={isChecked}
          onChange={handleChange}
        />
        <span className="checkbox-title">{title}</span>
      </div>
      {error ? <ErrorText error={error} /> : null}
    </>
  );
};

export default Checkbox;
